{
  "id": "mkt-coach-2026-10-19-01",
  "group_id": "86ef8e52-5df5-46b0-951b-ae5703fba880",
  "season_id": "season-2026-2027",
  "market_date": "2026-10-19",
  "closes_at": "2026-10-25T22:00:00Z",
  "minimum_bonus": 1000000,
  "status": "OPEN",
  "listings": [
    {
      "id": "c0010000-0000-0000-0000-000000000001",
      "name": "Marcelo Bielsa",
      "image_url": "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&auto=format&fit=crop&q=80",
      "attack": 6,
      "midfield": 5,
      "defense": 4,
      "updated_at": "2026-10-19T06:00:00Z"
    },
    {
      "id": "c0020000-0000-0000-0000-000000000002",
      "name": "Unai Emery",
      "image_url": "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&auto=format&fit=crop&q=80",
      "attack": 4,
      "midfield": 7,
      "defense": 4,
      "updated_at": "2026-10-19T06:00:00Z"
    },
    {
      "id": "c0030000-0000-0000-0000-000000000003",
      "name": "Diego Simeone",
      "image_url": "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&auto=format&fit=crop&q=80",
      "attack": 3,
      "midfield": 4,
      "defense": 8,
      "updated_at": "2026-10-19T06:00:00Z"
    }
  ]
}
